import { PageQueryParams } from '../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseCompanyConsultationsResponse } from '../useCompanyConsultations/useCompanyConsultations.types';

const PREFIX = '[companyInProgressConsultationsQuery]';

export const companyInProgressConsultationsQuery = async (params: PageQueryParams) => {
  console.log(PREFIX, `Fetching company in progress consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.allCompanyInProgressConsultations(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received company in progress consultations.`);
  return json as UseCompanyConsultationsResponse;
};
